import { FC, ReactElement, SyntheticEvent } from 'react';
import { Box, Popover, PopoverTrigger, PopoverContent, PopoverBody, PopoverArrow, useDisclosure } from '@chakra-ui/react';
import { CbNavigationLink } from './CbNavigationLink';
import { CbNavigationSubLink } from './CbNavigationSubLink';
import { NavigationLink } from '../../types/Navigation';
import { ICON_BY_NAME } from '../Icons/Icon';
export interface CbNavigationLinkPopoverProps {
  isActive: boolean;
  icon?: ReactElement;
  label: string;
  subLinks: NavigationLink[];
  onClick?: (event: SyntheticEvent) => void;
}
export const CbNavigationLinkPopover: FC<CbNavigationLinkPopoverProps> = ({
  isActive,
  icon,
  label,
  subLinks,
  onClick
}) => {
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclosure();
  const handleLinkClick = clickHandler => {
    clickHandler();
    onOpen();
  };
  return <Popover isOpen={isOpen} onClose={onClose} data-sentry-element="Popover" data-sentry-component="CbNavigationLinkPopover" data-sentry-source-file="CbNavigationLinkPopover.tsx">
      <CbNavigationLink color={isOpen || isActive ? 'white' : 'cloud.500'} display="flex" alignItems="center" isActive={isActive} icon={icon} pointerEvents={isOpen ? 'none' : 'auto'} renderAsButton onClick={event => onClick != null ? handleLinkClick(() => onClick?.(event)) : onOpen()} data-sentry-element="CbNavigationLink" data-sentry-source-file="CbNavigationLinkPopover.tsx">
        {label}
        <PopoverTrigger data-sentry-element="PopoverTrigger" data-sentry-source-file="CbNavigationLinkPopover.tsx">
          <Box backgroundColor={isOpen ? 'white' : 'transparent'} marginLeft="7px" transform={isOpen ? 'rotate(180deg)' : ''} borderRadius="50%" height="17px" width="17px" display="flex" alignItems="center" justifyContent="center" data-sentry-element="Box" data-sentry-source-file="CbNavigationLinkPopover.tsx">
            <ICON_BY_NAME.chevrondownwide color={isOpen ? 'luigisPants.500' : 'currentColor'} width="11px" data-sentry-element="unknown" data-sentry-source-file="CbNavigationLinkPopover.tsx" />
          </Box>
        </PopoverTrigger>
      </CbNavigationLink>
      <PopoverContent border="none" boxShadow="0px 20px 100px rgba(0, 0, 0, 0.2)" minWidth="176px" borderRadius={8} _focus={{
      boxShadow: '0px 20px 100px rgba(0, 0, 0, 0.2) !important',
      outline: 'none'
    }} data-sentry-element="PopoverContent" data-sentry-source-file="CbNavigationLinkPopover.tsx">
        <PopoverArrow boxShadow="none !important" data-sentry-element="PopoverArrow" data-sentry-source-file="CbNavigationLinkPopover.tsx" />
        <PopoverBody padding="0" borderRadius={8} overflow="hidden" data-sentry-element="PopoverBody" data-sentry-source-file="CbNavigationLinkPopover.tsx">
          {subLinks.map((link, index) => <CbNavigationSubLink key={link.label} as={link.as} hasBorderBottom={index === subLinks.length - 1 ? false : true} href={link.href} isActive={link.isActive} isExternal={link.isExternal} icon={link.icon} paddingY={3} renderAsButton={link.renderAsButton} onClick={onClose}>
              {link.label}
            </CbNavigationSubLink>)}
        </PopoverBody>
      </PopoverContent>
    </Popover>;
};